import { createSlice } from '@reduxjs/toolkit';

const studentIdSlice = createSlice({
  name: 'studentId',
  initialState: null, // Set initial state as needed
  reducers: {
    setStudentId: (state, action) => action.payload,
    clearStudentId: () => null,
  },
});

export const { setStudentId, clearStudentId } = studentIdSlice.actions;
export default studentIdSlice.reducer;